<template>
    <div class='quetationOrder'>
        <div class="opera-group" style="margin-bottom:10px;">
            <a-row>
                <a-col :span="4" style="margin:0 20px;">
                    <a-input v-model="form.quotationPrice" placeholder="项目名称"/>
                </a-col>
                <a-col :span="9" style="display:flex;margin-right:20px">
                    <a-date-picker
                        v-model="startValue"
                        :disabled-date="disabledStartDate"
                        show-time
                        format="YYYY-MM-DD HH:mm:ss"
                        placeholder="开始日期"
                          style="margin-right:20px;"
                        @openChange="handleStartOpenChange"
                        />
                     <a-date-picker
                        v-model="endValue"
                        :disabled-date="disabledEndDate"
                        show-time
                        format="YYYY-MM-DD HH:mm:ss"
                        placeholder="结束日期"
                        :open="endOpen"
                        @openChange="handleEndOpenChange"
                        />
                </a-col>
                <!-- <a-col :span="4" style="margin-right:20px;">
                    <a-select style="width: 100%"  v-model="form.invoiceStatus" placeholder="请选择是否开票">
                        <a-select-option value="1">未开票</a-select-option>
                        <a-select-option value="0">已开票</a-select-option>
                    </a-select>
                </a-col> -->
                 <a-col :span="4" style="margin-right:20px;">
                    <a-select style="width: 100%" v-model="form.orderState" placeholder="请选择订单状态">
                        <a-select-option value="0">待签署合同</a-select-option>
                        <a-select-option value="1">待支付尾款</a-select-option>
                        <a-select-option value="2">尾款待审核</a-select-option>
                        <a-select-option value="3">待验收</a-select-option>
                        <a-select-option value="4">已完成</a-select-option>
                    </a-select>
                </a-col>
                <a-col :span="4" style="margin-right:20px;">
                        <a-button type="primary" @click="search()" style="margin-right:20px;">查询</a-button></a-button>
                        <a-button type="primary" @click="clear()">重置</a-button>
                </a-col>
            </a-row>   
        </div>      
        <div class="manage-table">
            <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false"  :rowKey="(record,index)=>{return index}" >
                <span slot="orderNo" slot-scope="text">
                  <a-tooltip placement="topLeft">
                      <template slot="title">
                        <span> {{ text || '暂无' }}</span>
                      </template>
                      {{ text || '暂无' }}
                  </a-tooltip> 
                </span>
                <span slot="dealPrice" slot-scope="text">{{ text  }}元</span>
                <!-- <span slot="marginPrice" slot-scope="text">{{ text }}万元</span> -->
                <span slot="orderTime" slot-scope="text">
                  <a-tooltip placement="topLeft">
                      <template slot="title">
                        <span> {{ text }}</span>
                      </template>
                      {{ text }}
                  </a-tooltip> 
                </span>
                <span slot="projectName" slot-scope="text">
                  <a-tooltip placement="topLeft">
                      <template slot="title">
                        <span> {{ text }}</span>
                      </template>
                      {{ text }}
                  </a-tooltip> 
                </span>
                <template slot="action" slot-scope="text,record">
                    <div class="operate-btns">
                        <a-button v-if="record.orderState=='1'" @click="uploadwk(record)" type="primary">尾款支付凭证</a-button>
                        <a-button style="margin-left:10px;" v-if="record.buyerComplaint==0" type="primary" @click="complaint(record)">申诉</a-button>
                    </div>
                </template>
            </a-table>
        </div>    
        <pagination ref="pagination" :current="params.pageNum" :total="total" @getList="getList"></pagination> 
        <maindialog ref="maindialog" @getList="search"></maindialog>
        <complaint ref="complaint" @setlist="search"></complaint>
    </div>    
</template>
<script>
const columns = [
    {
      title: '订单编号',
      dataIndex: 'orderNo',
      width:180,
      scopedSlots: { customRender: 'orderNo' },
      ellipsis: true,
    },
    {
      title: '项目名称',
      dataIndex: 'projectName',
      width:100,
      scopedSlots: { customRender: 'orderNo' },
    },
      {
      title: '成交价',
      dataIndex: 'dealPrice',
      width:100,
      scopedSlots: { customRender: 'dealPrice' },
    },
    // {
    //   title: '流转保证金',
    //   dataIndex: 'marginPrice',
    //   width:100,
    //    scopedSlots: { customRender: 'marginPrice' },
    // },
    {
      title: '出让方名称',
      dataIndex: 'sellerName',
      width:100
    },
    {
      title: '订单状态',
      dataIndex: 'orderStateName',
      width: 100
    },
    {
      title: '下单时间',
      dataIndex: 'orderTime',
      width: 100,
      scopedSlots: { customRender: 'orderTime' },
    },
    {
      title: '操作',
      fixed: 'right',
      id:'8',
      dataIndex: 'operate',
      width: 220,
      scopedSlots: { customRender: 'action' },
    },
]
import maindialog from '@/views/BuyerCenter/itemOrder/components/maindialog.vue'
export default {
    components:{
        maindialog
    },
    data(){
        return{
            columns:columns,
            form:{
                quotationPrice:'',
                orderBeginDate:'',
                orderEndDate:'',
                orderState:undefined,
                isSeller:0,
                pageSize:10,
                pageNum:1
            },
             startValue: null,
            endValue: null,
            endOpen: false,
            loading:false,
            data:[],
            total:0,
            params:{
                pageSize:10,
                pageNum:1
            },
            currentId:''
        }
    },
    created(){
         this.$https.get('/portal/bidding/createBiddingOrder').then(res=>{})
         this.getDataList()
    },
    mounted(){
        this.$parent.activeIndex = 2;
    },
    methods:{
        complaint(record){
            record = JSON.stringify(record);
            let complaintType = 1; //申诉类型(0挂牌 1竞价)
            let complaintObj = 0;//申诉对象(0 买家 1卖家)
            this.$refs.complaint.showDialog(record,complaintType,complaintObj);
        },
        disabledStartDate(startValue) {
            const endValue = this.endValue;
            if (!startValue || !endValue) {
                return false;
            }
            return startValue.valueOf() > endValue.valueOf();
        },
        disabledEndDate(endValue) {
            const startValue = this.startValue;
            if (!endValue || !startValue) {
                return false;
            }
            return startValue.valueOf() >= endValue.valueOf();
        },
        handleStartOpenChange(open) {
            if (!open) {
                this.endOpen = true;
            }
        },
        handleEndOpenChange(open) {
             this.endOpen = open;
        },
        search(){
            this.form.pageSize=10;
            this.form.pageNum=1;
            this.getDataList();
        },
        getList(page){
            this.params.pageNum = page;
            this.getDataList();
        },
        getDataList(){
            this.loading = true;
              if(this.startValue){
                this.form.orderBeginDate = this.$utils.formatDateMytime(this.startValue);
            }
            if(this.endValue){
               this.form.orderEndDate = this.$utils.formatDateMytime(this.endValue)
            }
            this.$https.get('/portal/bidding/selectBgProjectOrderList',{params:this.form}).then(res=>{
               this.loading = false;
               if(res.code == 200){
                  this.data = res.rows;
                  //判断下单时间是否有30分钟
                  this.total = Number(res.total);
               }
            }).catch(error=>{
                this.loading = false;
            })
        },
        clear(){
            this.form = {
                quotationPrice:'',
                orderBeginDate:'',
                orderEndDate:'',
                invoiceStatus:undefined,
                orderState:undefined
            };
            this.search();
        },
        uploadwk(row){
            this.$refs.maindialog.showDialog(row)
        }
    }
}
</script>
<style lang="less" scoped>

</style>